<template>
	<!-- Main content -->
	<div class="content-wrapper">

		<!-- Page header -->
		<app-breadcrumb/>
		<!-- /page header -->

		<!-- Content area -->
		<div class="content">

			<!-- Simple panel -->
			<div class="panel panel-flat border-top-lg border-top-success">
				<h6 class="panel-heading">General</h6>
				<div class="panel-body">
					
					<!--begin::Form-->
					<form class="form-horizontal" @submit.prevent="onEditGeneralSettings">

							  <div class="row">

							    <div class="col-md-12">

									<!-- begin::input-group Embed Title -->
									<div class="input-group">
										<div class="input-group-btn">
											<button type="button" class="btn btn-success">Embed Title</button>

											<span class="ml-1">								
												<select name="embed_title_status" v-model="cloneSettings.embed_title_status" class="btn border-success text-success-600 btn-flat dropdown-toggle" required="required">
													<option value="0">Disabled</option>
													<option value="1">Enabled</option>
												</select>
											</span>

										</div>
 										<input type="text" class="form-control" v-model="cloneSettings.embed_title" name="embed_title" placeholder="APICodes Embed Player v2">				
									</div>
									<!-- end::input-group Embed Title -->
							    </div>

							    <div class="col-md-12 mt-5">
							    	<div class="alert alert-info">
							    		<button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button>
							    		<p><b>Enabled:</b> The name above will be used as the title in Embed Player.</p>
							    		<p><b>Disabled:</b> The movie, serie, or episode names will be used as titles in the Embed Player.</p>
							    	</div>
							    </div>

<!-- 							    <div class="col-md-4">
									<div class="input-group">
										<div class="input-group-btn">
											<button type="button" class="btn btn-success">Movie Embed Slug</button>
										</div>
										<input type="text" class="form-control" v-model="cloneSettings.movie_embed_slug" name="movie_embed_slug" placeholder="mv">
									</div>
							    </div>

							    <div class="col-md-4">
									<div class="input-group">
										<div class="input-group-btn">
											<button type="button" class="btn btn-success">Serie Embed Slug</button>
										</div>
										<input type="text" class="form-control" v-model="cloneSettings.serie_embed_slug" name="serie_embed_slug" placeholder="tv">
									</div>
							    </div> -->

							  </div>

				        <!--begin::Modal Footer -->
				        <div class="modal-footer p-0 pt-10">
				            <button class="btn btn-info" data-style="zoom-out" type="submit" title="Save changes"><i class="icon-checkmark2"></i> Save changes</button>
				            <button class="btn btn-danger" data-style="zoom-out" type="button" title="Reset all" @click.prevent="onResetGeneralSettings(cloneSettings.id)"><i class="icon-trash"></i> Reset all</button>
				        </div>
				        <!--end::Modal Footer -->
					</form>

				</div>

			</div>
			<!-- /simple panel -->

			<!-- begin::Player -->
			<div class="panel panel-flat border-top-lg border-top-success">
				<h6 class="panel-heading">Player</h6>
				<div class="panel-body">

					<form class="form-horizontal" @submit.prevent="onEditPlayerSettings">
						<!-- begin::input-group JWPlayer -->
						<div class="input-group">
							<div class="input-group-btn">
								<select name="jw_version" v-model="cloneSettings.jw_version" @change="onChangeJWVersion" class="btn border-success text-success-600 btn-flat dropdown-toggle" required="required">
									<option value="jw7">JWPlayer 7</option>
									<option value="jw8">JWPlayer 8</option>
								</select>
							</div>

							  <div class="row">
							    <div class="col-md-6">
							      <input type="text" class="form-control" id="jw_key" name="jw_key" v-model="cloneSettings.jw_key" placeholder="64HPbvSQorQcd52B8XFuhMtEoitbvY/EXJmMBfKcXZQU2Rnn">
							    </div>
							    <div class="col-md-6">
							      <input type="text" class="form-control" id="jw_link" name="jw_link" v-model="cloneSettings.jw_link" placeholder="https://ssl.p.jwpcdn.com/player/v/8.8.6/jwplayer.js">
							    </div>
							  </div>						
							
						</div>
						<!-- end::input-group JWPlayer -->
						<br>
						<!-- begin::input-group logo -->
						<div class="input-group">
							<div class="input-group-btn">
								<button type="button" class="btn btn-success">Logo</button>
								
								<span class="ml-1">								
									<select name="logo_position" v-model="cloneSettings.logo_position" class="btn border-success text-success-600 btn-flat dropdown-toggle" required="required">
										<option value="top-right">Top-Right</option>
										<option value="top-left">Top-Left</option>
										<option value="bottom-right">Bottom-Right</option>
										<option value="bottom-left">Bottom-Left</option>
										<option value="control-bar">Control-Bar</option>
									</select>
								</span>

								<span class="ml-1">	
									<select name="logo_status" v-model="cloneSettings.logo_status" class="btn border-success text-success-600 btn-flat dropdown-toggle" required="required">
										<option value="0">Disabled</option>
										<option value="1">Enabled</option>
									</select>
								</span>
							</div>

							  <div class="row">
							    <div class="col-md-6">
							      <input type="text" class="form-control" name="logo_link" v-model="cloneSettings.logo_link" placeholder="https://apicodes.com/logo.png">
							    </div>
							    <div class="col-md-6">
							      <input type="text" class="form-control" name="logo_homepage" v-model="cloneSettings.logo_homepage" placeholder="https://apicodes.com">
							    </div>
							  </div>

							
						</div>
						<!-- end::input-group logo -->

						<br>

						<!-- begin::input-group poster -->
						<div class="input-group">
							<div class="input-group-btn">
								<button type="button" class="btn btn-success">Default Poster</button>

								<select name="poster_status" v-model="cloneSettings.poster_status" class="btn border-success text-success-600 btn-flat dropdown-toggle" required="required">
									<option value="0">Disabled</option>
									<option value="1">Enabled</option>
								</select>
							</div>

							<input type="text" class="form-control" name="poster_link" v-model="cloneSettings.poster_link" placeholder="https://apicodes.com/poster.png">
						</div>
						<!-- end::input-group poster -->

				        <!--begin::Modal Footer -->
				        <div class="modal-footer p-0 pt-10">
				            <button class="btn btn-info" data-style="zoom-out" type="submit" title="Save changes"><i class="icon-checkmark2"></i> Save changes</button>
				            <button class="btn btn-danger" data-style="zoom-out" type="button" title="Reset all" @click.prevent="onResetPlayerSettings(cloneSettings.id)"><i class="icon-trash"></i> Reset all</button>
				        </div>
				        <!--end::Modal Footer -->
					</form>

				</div>
			</div>
			<!-- end::Player -->

			<!-- begin::Advertisement -->
			<div class="panel panel-flat border-top-lg border-top-success">
				<h6 class="panel-heading">Advertisement</h6>
				<div class="panel-body">
					
					<form class="form-horizontal" @submit.prevent="onEditAdvertisementSettings">
						<!-- begin::input-group Pop-Under Ads -->
						<div class="input-group">
							<div class="input-group-btn">
								<button type="button" class="btn btn-success">Pop-Under Ads</button>

								<select name="popunder_ads_status" v-model="cloneSettings.popunder_ads_status" class="btn border-success text-success-600 btn-flat dropdown-toggle" required="required">
									<option value="0">Disabled</option>
									<option value="1">Enabled</option>
								</select>
							</div>

							<input type="text" class="form-control" name="popunder_ads_link" v-model="cloneSettings.popunder_ads_link" placeholder="https://go.pub2srv.com/apu.php?zoneid=123456">
						</div>
						<!-- end::input-group Pop-Under Ads -->

						<br>

						<!-- begin::input-group Banner Ads -->
						<div class="input-group">
							<div class="input-group-btn">
								<button type="button" class="btn btn-success">Banner Ads</button>

								<select name="banner_ads_status" v-model="cloneSettings.banner_ads_status" class="btn border-success text-success-600 btn-flat dropdown-toggle" required="required">
									<option value="0">Disabled</option>
									<option value="1">Enabled</option>
								</select>
							</div>

							<input type="text" class="form-control" name="banner_ads_code" v-model="cloneSettings.banner_ads_code" placeholder="Put your script or html code to here...">
						</div>
						<!-- end::input-group Banner Ads -->
						<br>

						<!-- begin::input-group Vast Ads -->
						<div class="input-group">
							<div class="input-group-btn">
								<button type="button" class="btn btn-success">Vast Ads</button>

								<select name="vast_ads_status" v-model="cloneSettings.vast_ads_status" class="btn border-success text-success-600 btn-flat dropdown-toggle" required="required">
									<option value="0">Disabled</option>
									<option value="1">Enabled</option>
								</select>
							</div>
							
							<div class="row">
								<div class="col-md-6">
									<input type="text" class="form-control" name="vast_ads_link" v-model="cloneSettings.vast_ads_link" placeholder="https://playertest.longtailvideo.com/vast-30s-ad.xml">
								</div>

								<div class="col-md-6">
									<div class="input-group-inline mb-5">
										<span class="input-group-prepend-inline">
											<button class="btn btn-icon">Skippable - Allow skip after</button>
										</span>
										<input type="text" class="form-control border-left-0" name="vast_ads_skippable" v-model="cloneSettings.vast_ads_skippable" placeholder="5">
										<span class="input-group-append-inline">
											<button class="btn btn-icon">Second(s)</button>
										</span>
									</div>
								</div>

							</div>

						</div>
						<!-- end::input-group Vast Ads -->

				        <!--begin::Modal Footer -->
				        <div class="modal-footer p-0 pt-10">
				            <button class="btn btn-info" data-style="zoom-out" type="submit" title="Save changes"><i class="icon-checkmark2"></i> Save changes</button>
				            <button class="btn btn-danger" data-style="zoom-out" type="button" title="Reset all" @click.prevent="onResetAdvertisementSettings(cloneSettings.id)"><i class="icon-trash"></i> Reset all</button>
				        </div>
				        <!--end::Modal Footer -->
					</form>
				
				</div>
			</div>
			<!-- end::Advertisement -->

			<!-- begin::Captions Styling -->
			<div class="panel panel-flat border-top-lg border-top-success">
				<h6 class="panel-heading">Captions Styling (<a href="https://www.jwplayer.com/developers/web-player-demos/captions-styling/" class="font-weight-bold" target="_blank">Live demo here</a>)</h6>
				<div class="panel-body">

					<form @submit.prevent="onEditCaptionsSettings">
						<div class="row">

						  <div class="form-group col-md-3">
						    <label for="text_color">Text color</label>
						    <input type="text" class="form-control" name="text_color" v-model="cloneSettings.text_color" placeholder="#f3f378">
						  </div>

						  <div class="form-group col-md-3">
						    <label for="font_size">Font Size</label>
						    <input type="text" class="form-control" name="font_size" v-model="cloneSettings.font_size" placeholder="15">
						  </div>

						  <div class="form-group col-md-3">
						    <label for="font_family">Font Family</label>
							<select class="form-control" name="font_family" v-model="cloneSettings.font_family">
								<option value="default">Default</option>
								<option value="helvetica">Helvetica</option>
								<option value="serif">Serif</option>
								<option value="sans-serif">Sans Serif</option>
								<option value="monospace">Monospace</option>
								<option value="fantasy">Fantasy</option>
								<option value="cursive">Cursive</option>
							</select>
						  </div>

						  <div class="form-group col-md-3">
						    <label for="background_color">Background Color</label>
						    <input type="text" class="form-control" name="background_color" v-model="cloneSettings.background_color" placeholder="#000000">
						  </div>

						</div>

						<div class="row">

						  <div class="form-group col-md-3">
						    <label for="background_opacity">Background Opacity</label>
						    <input type="text" class="form-control" name="background_opacity" v-model="cloneSettings.background_opacity" placeholder="0">
						  </div>

						  <div class="form-group col-md-3">
						    <label for="edge_style">Edge Style</label>
							<select class="form-control" name="edge_style" v-model="cloneSettings.edge_style">
								<option value="none">None</option>
								<option value="dropshadow">Drop Shadow</option>
								<option value="raised">Raised</option>
								<option value="depressed">Depressed</option>
								<option value="uniform">Uniform</option>
							</select>
						  </div>

						  <div class="form-group col-md-3">
						    <label for="window_color">Window Color</label>
						    <input type="text" class="form-control" name="window_color" v-model="cloneSettings.window_color" placeholder="#000000">
						  </div>

						  <div class="form-group col-md-3">
						    <label for="windows_opacity">Windows Opacity</label>
						    <input type="text" class="form-control" name="windows_opacity" v-model="cloneSettings.windows_opacity" placeholder="0">
						  </div>

						</div>

						<div class="row">

						  <div class="form-group col-md-3">
						    <label for="video_autostart">Video autostart</label>
							<select name="video_autostart" class="form-control" v-model="cloneSettings.video_autostart">
								<option value="false">Disabled</option>
								<option value="true">Enabled</option>
							</select>
						  </div>

						  <div class="form-group col-md-3">
						    <label for="share_button">Share button</label>
							<select name="share_button" class="form-control" v-model="cloneSettings.share_button">
								<option value="0">Disabled</option>
								<option value="1">Enabled</option>
							</select>
						  </div>

						  <div class="form-group col-md-3">
						    <label for="download_button">Download button</label>
							<select name="download_button" class="form-control" v-model="cloneSettings.download_button">
								<option value="0">Disabled</option>
								<option value="1">Enabled</option>
							</select>
						  </div>

						  <div class="form-group col-md-3">
						    <label for="auto_resume">Auto Resume</label>
							<select name="auto_resume" class="form-control" v-model="cloneSettings.auto_resume">
								<option value="0">Disabled</option>
								<option value="1">Enabled</option>
							</select>
						  </div>

						</div>
					
				        <!--begin::Modal Footer -->
				        <div class="modal-footer p-0 pt-10">
				            <button class="btn btn-info" data-style="zoom-out" type="submit" title="Save changes"><i class="icon-checkmark2"></i> Save changes</button>
				            <button class="btn btn-danger" data-style="zoom-out" type="button" title="Reset all" @click.prevent="onResetCaptionsSettings(cloneSettings.id)"><i class="icon-trash"></i> Reset all</button>
				        </div>
				        <!--end::Modal Footer -->
				    </form>

				</div>

			</div>


			<!-- Footer -->
			<app-footer/>
			<!-- /footer -->

		</div>
		<!-- /content area -->
	</div>
	<!-- /main content -->
</template>

<script>
import axios from 'axios'
import lodash from 'lodash'
const token = localStorage.getItem('token')

export default {
  name: 'Settings',
  data () {
    return { 
    	jw_key: '',
    	jw_link: ''
    }
  },
  computed: {
    settings() {
      return this.$store.getters.settings
    },
    cloneSettings(){
      return _.cloneDeep(this.settings)
    }
  },
  mounted() {
  	let vm = this;
  	Ladda.bind('button[type=submit]')
    return this.$store.dispatch('loadDataSettings')
  },
  methods: {
  		onChangeJWVersion(e){
  			let vm = this;
  			if (e.target.value == 'jw7') {
  				$('#jw_key').val('LgLP3h9VAPYU1gxeWx2Vb/JbPuUOH0omT0vj4qWYcpAYZmo2');
  				$('#jw_link').val('https://ssl.p.jwpcdn.com/player/v/7.12.13/jwplayer.js');
  				this.cloneSettings.jw_key = 'LgLP3h9VAPYU1gxeWx2Vb/JbPuUOH0omT0vj4qWYcpAYZmo2';
  				this.cloneSettings.jw_link = 'https://ssl.p.jwpcdn.com/player/v/7.12.13/jwplayer.js';
  			}
  			else{
  				$('#jw_key').val('64HPbvSQorQcd52B8XFuhMtEoitbvY/EXJmMBfKcXZQU2Rnn');
  				$('#jw_link').val('https://ssl.p.jwpcdn.com/player/v/8.8.6/jwplayer.js');
  				this.cloneSettings.jw_key = '64HPbvSQorQcd52B8XFuhMtEoitbvY/EXJmMBfKcXZQU2Rnn';
  				this.cloneSettings.jw_link = 'https://ssl.p.jwpcdn.com/player/v/8.8.6/jwplayer.js';
  			}
  		},
		onEditGeneralSettings(){
		    this.$store.commit('onEditGeneralSettings', this.cloneSettings)
		},
		onResetGeneralSettings(id){
			let vm = this;
			Swal.fire({
				title: "Are you sure?",
				text: "You will not be able to recover this Settings!",
				type: "warning",
				showCancelButton: true,
				confirmButtonColor: "#FF7043",
				confirmButtonText: "Yes, reset it!"
			}).then((result) => {
				  if (result.value) {
					axios.post('setting/general/reset?token=' + token, {'id': id})
					.then(function (response) {
						Ladda.stopAll()
						vm.$store.dispatch('loadDataSettings')
						vm.notify('success_edit')
					})
					.catch(function (error) {
						Ladda.stopAll()
						vm.notify('error_edit')
					});
				  }
				});
		},
		//
		onEditPlayerSettings(){
		    this.$store.commit('onEditPlayerSettings', this.cloneSettings)
		},
		onResetPlayerSettings(id){
			let vm = this;
			Swal.fire({
				title: "Are you sure?",
				text: "You will not be able to recover this Settings!",
				type: "warning",
				showCancelButton: true,
				confirmButtonColor: "#FF7043",
				confirmButtonText: "Yes, reset it!"
			}).then((result) => {
				  if (result.value) {
					axios.post('setting/player/reset?token=' + token, {'id': id})
					.then(function (response) {
						Ladda.stopAll()
						vm.$store.dispatch('loadDataSettings')
						vm.notify('success_edit')
					})
					.catch(function (error) {
						Ladda.stopAll()
						vm.notify('error_edit')
					});
				  }
				});
		},
		//
		onEditAdvertisementSettings(){
		    this.$store.commit('onEditAdvertisementSettings', this.cloneSettings)
		},
		onResetAdvertisementSettings(id){
			let vm = this;
			Swal.fire({
				title: "Are you sure?",
				text: "You will not be able to recover this Settings!",
				type: "warning",
				showCancelButton: true,
				confirmButtonColor: "#FF7043",
				confirmButtonText: "Yes, reset it!"
			}).then((result) => {
				  if (result.value) {
					axios.post('setting/ads/reset?token=' + token, {'id': id})
					.then(function (response) {
						Ladda.stopAll()
						vm.$store.dispatch('loadDataSettings')
						vm.notify('success_edit')
					})
					.catch(function (error) {
						Ladda.stopAll()
						vm.notify('error_edit')
					});
				  }
				});
		},
		//
		onEditCaptionsSettings(){
		    this.$store.commit('onEditCaptionsSettings', this.cloneSettings)
		},
		onResetCaptionsSettings(id){
			let vm = this;
			Swal.fire({
				title: "Are you sure?",
				text: "You will not be able to recover this Settings!",
				type: "warning",
				showCancelButton: true,
				confirmButtonColor: "#FF7043",
				confirmButtonText: "Yes, reset it!"
			}).then((result) => {
				  if (result.value) {
					axios.post('setting/captions/reset?token=' + token, {'id': id})
					.then(function (response) {
						Ladda.stopAll()
						vm.$store.dispatch('loadDataSettings')
						vm.notify('success_edit')
					})
					.catch(function (error) {
						Ladda.stopAll()
						vm.notify('error_edit')
					});
				  }
				});
		}
		//
  }
}
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/components/admin/Settings.vue